// React import
import * as React from 'react';
// Standard layout imports
import Wrapper from 'src/components/Wrapper';

import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import { ActivityCategorySelector } from 'src/Entities/ActivityCategory/ActivityCategory.Selector';
import { ActivityThemeSelector } from 'src/Entities/ActivityTheme/ActivityTheme.Selector';
import CoursesThemeComponent from './CourseTheme.component';
import FlexContainer from 'src/components/Layout/FlexContainer';
import SearchComponent from '../SeachPage/Seach.component';
import { UserSelector } from 'src/Entities/User/User.Selector';
import { setSlecetedActivtyAction } from 'src/Entities/PortalState/PortalState.Actions';

interface IProps {
  themes: IActivityThemeModel[];
  showIntrests: boolean;
  setSelectedActivity: (
    detailKursusid: string,
    themeId: string,
    categoryId: string
  ) => void;
}
interface IState {
  shouldRedirect: boolean;
}
class CoursesPage extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { shouldRedirect: false };
    this.activitySelected = this.activitySelected.bind(this);
  }
  public activitySelected(
    detailKursusId: string,
    themeId: string,
    categoryId: string
  ) {
    this.props.setSelectedActivity(detailKursusId, themeId, categoryId);
    this.setState({ shouldRedirect: true });
  }
  public render() {
    return (
      <div>
        <Wrapper>
          <FlexContainer justifyContent="between" className="pt3">
            <div>
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to="/Home">FORSIDE</Link>{' '}
                </BreadcrumbItem>
                <BreadcrumbItem active={true}>
                  <Link to="/kurser/">KURSER</Link>{' '}
                </BreadcrumbItem>
              </Breadcrumb>
            </div>
          </FlexContainer>
        </Wrapper>

        {/* SEARCHBAR */}
        <div className="has-background-gray-body mt-16">
          <Wrapper>
            <div style={{ transform: 'translateY(-40px)' }}>
              <SearchComponent />
            </div>
          </Wrapper>
          <div className="pb4">
            {this.props.themes.map(t => (
              <CoursesThemeComponent
                key={t.themeId}
                theme={t}
                categories={ActivityCategorySelector.getCategoriesByThemeId(
                  t.themeId,
                  this.props.showIntrests
                )}
                onActivitySelected={this.activitySelected}
              />
            ))}
            {this.state.shouldRedirect ? (
              <Redirect to="/kursus/" push={true} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any, ownProps: any) {
  const themeId = ownProps.match.params.themeid;
  return {
    themes: ActivityThemeSelector.getThemes(),
    showIntrests: UserSelector.isShowOnlyUserIntrests()
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  return {
    setSelectedActivity: (
      detailKursusid: string,
      themeId: string,
      categoryId: string
    ) => dispatch(setSlecetedActivtyAction(detailKursusid, themeId, categoryId))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CoursesPage);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Courses/index.tsx